import gql from "graphql-tag";

export default gql`
  query getOrderPartner($orderId: ID!, $userId: ID!) {
    getOrderPartner(orderId: $orderId, userId: $userId) {
      orderId
      userId
      comments
      files {
        key
        bucket
        identityId
        region
      }
      status
      updatedAt
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Query/GetOrderPartner.js